<template>
  <div class="page-form">
    <div class="form__wrapper">
      <div class="form__item">
        <p>Your IP address has been confirmed successfully.</p>
      </div>
    </div>
    <div class="form__controls">
      <div class="form__submit">
        <button type="button" class="page-button" @click="$emit('close')">
          <span></span><span>Continue</span><span></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'IpConfirmedForm',
    props: {
        options: Object,
    },
}
</script>
